export const NotActive = Symbol('notActive');
